import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { BoxPrivate } from '../../_primitives/box/box.esm.js';

var _excluded = ["variant", "className", "fillContainer"];
var Container = /*#__PURE__*/React.forwardRef(function Container(props, ref) {
  var _variant = props.variant,
    className = props.className,
    fillContainer = props.fillContainer,
    rest = _objectWithoutProperties(props, _excluded);
  var variant = _variant ? "container.".concat(_variant) : 'container';
  var __css = useMemo(function () {
    return fillContainer ? {
      inset: 0,
      bottom: 0,
      left: 0,
      right: 0
    } : {
      width: '100%',
      minWidth: 0,
      mx: 'auto'
    };
  }, [fillContainer]);
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    ref: ref,
    variant: variant,
    className: classNames({
      'csg-tui-container': true
    }, className),
    relative: fillContainer ? false : true,
    absolute: fillContainer ? true : false
  }, rest, {
    __themeKey: "layout",
    __css: __css
  }));
});

export default Container;
//# sourceMappingURL=container.esm.js.map
